import React from 'react';
import clsx from 'clsx'

import { AppButtonProps, UI_BUTTON_TYPE } from './AppButtonProps'
import AppLoader from '../AppLoader/AppLoader'

import './AppButtonStyles.scss'


/**
 * ATOM - Komponent przycisku aplikacji w różnych wariantach stylu.
 * @param {React.ReactNode | React.ReactNode[]} children - Content przycisku - można przekazać albo zwykły tekst, albo komponenty Reacta (np. tekst i ikonę) 
 * @param {Function} onClick - Funkcja wywoływana po kliknięciu przycisku
 * @param {Boolean} isLoading - Jeśli true, przycisk pokazuje loader i blokuje akcję kliknięcia. Niedostępne dla PRIMARY_OUTLINE
 * @param {Boolean} disabled - Jeśli true, przycisk jest nieaktywny i blokuje akcję kliknięcia
 * @param {UI_BUTTON_TYPE} uiButtonType - Typ przycisku określający jego styl
 * @param {String} className - Dodatkowa klasa pozwalająca dodać customowe właściwości
 * @returns 
 */
const AppButton = (props: AppButtonProps) => {

   const { 
      isLoading, children, className, disabled, type,
      onClick, uiButtonType = UI_BUTTON_TYPE.PRIMARY, ...rest
   } = props


   const handleOnClick = (e: React.MouseEvent<HTMLButtonElement>) => {
      if (disabled || isLoading) { // Jeśli disabled lub loading, blokujemy akcję kliknięcia
         return
      }
      else {
         onClick(e)
      }
   }

   return (
      <button
         type={type}
         disabled={disabled || isLoading}
         onClick={handleOnClick}
         aria-busy={isLoading}
         aria-disabled={disabled || isLoading}
         className={
            clsx(className, 'app-button', `app-button--${uiButtonType.toLowerCase()}`, isLoading && 'app-button--loading'
         )}
         {...rest}
      >
         {(isLoading && uiButtonType !== UI_BUTTON_TYPE.PRIMARY_OUTLINE)? <AppLoader height={uiButtonType === UI_BUTTON_TYPE.PRIMARY? 40 : 'auto'} barWidth={5} /> : children}
      </button>
   )
}

export default AppButton